import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import AddPreorderItemForm from './AddPreorderItemForm';

interface AddItemsDialogProps {
  open: boolean;
  onClose: () => void;
  preorderEventId?: number;
  preorderVendorId?: number;
}

const AddItemsDialog: React.FC<AddItemsDialogProps> = ({
  open,
  onClose,
  preorderEventId,
  preorderVendorId
}) => {
  const { t } = useTranslation('global');

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="md" 
      fullWidth
      PaperProps={{
        style: {
          maxHeight: '90vh',
          height: '90vh'
        }
      }}
    >
      <DialogTitle style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: 16
      }}>
        <Typography variant="h6">
          {t('preorderEventDetails.add-items')}
        </Typography>
        <IconButton 
          aria-label="close" 
          onClick={handleClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent 
        dividers 
        style={{ 
          padding: 0,
          overflow: 'hidden'
        }}
        className="modal-form"
      >
        <div style={{ 
          height: '100%', 
          overflow: 'auto',
          padding: '20px'
        }}>
          <AddPreorderItemForm 
            preorderEventId={preorderEventId || 0}
            preorderVendorId={preorderVendorId}
            onItemAdded={handleClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddItemsDialog;